// src/services/programApi.js - КОМПЛЕТЕН СО СИТЕ МЕТОДИ
import api from './api';

const programAPI = {
    // ===== USER ENDPOINTS =====

    // Земи ги сите програми (public)
    getAll: async () => {
        try {
            const res = await api.get('/programs');
            return res.data || [];
        } catch (error) {
            console.error('Error fetching programs:', error);
            throw error;
        }
    },

    // Земи програма по ID (public)
    getById: async (id) => {
        try {
            const res = await api.get(`/programs/${id}`);
            return res.data;
        } catch (error) {
            console.error('Error fetching program by ID:', error);
            throw error;
        }
    },

    // Пребарување програми
    search: async (name) => {
        try {
            const res = await api.get(`/programs/search?name=${encodeURIComponent(name)}`);
            return res.data || [];
        } catch (error) {
            console.error('Error searching programs:', error);
            throw error;
        }
    },

    // 👇 КУПУВАЊЕ НА ПРОГРАМА (authenticated)
    purchase: async (id) => {
        try {
            console.log('💳 API: Purchasing program:', id);
            const res = await api.post(`/programs/${id}/purchase`);
            console.log('✅ API: Purchase successful:', res.data);
            return res.data;
        } catch (error) {
            console.error('❌ API: Error purchasing program:', error);
            throw error;
        }
    },

    // 👇 МОИ КУПЕНИ ПРОГРАМИ (authenticated)
    getMyPrograms: async () => {
        try {
            console.log('📋 API: Fetching my programs...');
            const res = await api.get('/programs/my-programs');
            console.log('✅ API: My programs:', res.data);
            return res.data || [];
        } catch (error) {
            console.error('❌ API: Error fetching my programs:', error);
            throw error;
        }
    },

    // Детали за програма (authenticated - само за купувачи)
    getDetails: async (id) => {
        try {
            const res = await api.get(`/programs/${id}/details`);
            return res.data;
        } catch (error) {
            console.error('Error fetching program details:', error);
            throw error;
        }
    },

    // Преостанати денови
    getRemainingDays: async (id) => {
        try {
            const res = await api.get(`/programs/${id}/remaining-days`);
            return res.data;
        } catch (error) {
            console.error('Error fetching remaining days:', error);
            throw error;
        }
    },

    // Намали денови
    decreaseRemainingDays: async (id) => {
        try {
            const res = await api.post(`/programs/${id}/decrease-days`);
            return res.data;
        } catch (error) {
            console.error('Error decreasing remaining days:', error);
            throw error;
        }
    },

    // ===== ADMIN ENDPOINTS =====
    admin: {
        getAll: async () => {
            try {
                const res = await api.get('/admin/programs');
                return res.data || [];
            } catch (error) {
                console.error('Error fetching admin programs:', error);
                throw error;
            }
        },

        getById: async (id) => {
            try {
                const res = await api.get(`/admin/programs/${id}`);
                return res.data;
            } catch (error) {
                console.error('Error fetching admin program by ID:', error);
                throw error;
            }
        },

        create: async (programData) => {
            try {
                const res = await api.post('/admin/programs', programData);
                return res.data;
            } catch (error) {
                console.error('Error creating program:', error);
                throw error;
            }
        },

        update: async (id, programData) => {
            try {
                const res = await api.put(`/admin/programs/${id}`, programData);
                return res.data;
            } catch (error) {
                console.error('Error updating program:', error);
                throw error;
            }
        },

        delete: async (id) => {
            try {
                await api.delete(`/admin/programs/${id}`);
            } catch (error) {
                console.error('Error deleting program:', error);
                throw error;
            }
        },

        addDay: async (programId, dayId) => {
            try {
                const res = await api.post(`/admin/programs/${programId}/days/${dayId}`);
                return res.data;
            } catch (error) {
                console.error('Error adding day to program:', error);
                throw error;
            }
        },

        removeDay: async (programId, dayId) => {
            try {
                await api.delete(`/admin/programs/${programId}/days/${dayId}`);
            } catch (error) {
                console.error('Error removing day from program:', error);
                throw error;
            }
        },

        search: async (name) => {
            try {
                const res = await api.get(`/admin/programs/search?name=${encodeURIComponent(name)}`);
                return res.data || [];
            } catch (error) {
                console.error('Error searching admin programs:', error);
                throw error;
            }
        }
    }
};

export default programAPI;